// extracted by mini-css-extract-plugin
module.exports = {"Switch":"Switch_Switch__1HwLP","SwitchInput":"Switch_SwitchInput__3diEQ","SwitchSlider":"Switch_SwitchSlider__2SD5B"};